export const DOCUMENT_FRAGMENT = `
  documentCategory
  documentType
  key
  name
  size
  dateUploaded
  completed
  hash
`;

export const DOCUMENT_LIST_FRAGMENT = `
  optOut
  documents {
    ${DOCUMENT_FRAGMENT}
  }  
`;

export const DOCUMENT_LIST_TITLE_FRAGMENT = `
  ${DOCUMENT_LIST_FRAGMENT}  
  title
`;
